<div class="container-fluid">
  <div class="card">

    <!-- ── Header ──────────────────────────────────────────────────────── -->
    <div class="card-header nocollapse">Manage Survey and Provider Company</div>

    <!-- ── Row 1: Service line name + Home button ──────────────────────── -->
    <div class="bg-info sl-name-bar">
      <span><b>Service Line Name: </b>{{ serviceLineName }}</span>
      <button class="btn btn-sm btn-primary btn-action" (click)="backUrl()">
        <i class="fa fa-home"></i> Home
      </button>
    </div>

    <!-- ── Row 2: Status message (only visible when set) ───────────────── -->
    <div *ngIf="successOrFailureMessage !== ''"
         class="card-header nocollapse bg-info msg-bar">
      <i class="fa fa-info-circle fa-lg" style="color:#326295;"></i>
      <b>{{ successOrFailureMessage }}</b>
    </div>

    <!-- ── Row 3: Two-panel layout ─────────────────────────────────────── -->
    <div class="two-panel-layout">

      <!-- Left panel: Surveys (60%) -->
      <div class="panel-left">
        <div class="panel-toolbar">
          <button class="btn btn-sm btn-primary btn-action" (click)="openAddSurveyModal()">
            <i class="fa fa-user-plus"></i> Add Survey
          </button>
          <button class="btn btn-sm btn-primary btn-action" (click)="openEmailDetailsModal()">
            <i class="fa fa-envelope"></i> Email Configuration
          </button>
          <button *ngIf="isConsip" class="btn btn-sm btn-primary btn-action"
                  (click)="navigateToConsipConfig()">
            <i class="fa fa-gear"></i> Configure Consip
          </button>
        </div>
        <div class="grid-wrapper">
          <isg-grid [rowData]="serviceLineSurveyMapList"
                    [columnDefs]="mappedSurveyColumns"
                    [defaultColDef]="defaultColDef"
                    [config]="gridConfig">
          </isg-grid>
        </div>
      </div>

      <!-- Right panel: Service Providers (40%) -->
      <div class="panel-right">
        <div class="panel-toolbar">
          <button class="btn btn-sm btn-primary btn-action" (click)="openAddProviderModal()">
            <i class="fa fa-user-plus"></i> Add Service Provider
          </button>
          <button class="btn btn-sm btn-primary btn-action"
                  (click)="modalRef = modalService.open(usersDownloadModal)">
            <i class="fa fa-download"></i> Download Users
          </button>
        </div>
        <div class="grid-wrapper">
          <isg-grid [rowData]="serviceLineServiceProviderMapList"
                    [columnDefs]="mappedServiceProviderColumns"
                    [defaultColDef]="defaultColDef"
                    [config]="gridConfig">
          </isg-grid>
        </div>
      </div>

    </div><!-- /.two-panel-layout -->

  </div>
</div>

<!-- ── Map Surveys Modal ─────────────────────────────────────────────────── -->
<ng-template #mapSurveyModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Map Survey(s)</h5>
    <button type="button" class="btn-close" aria-label="Close"
            (click)="modal.dismiss(); surveyForm.reset()"></button>
  </div>
  <div class="modal-body p-0">
    <div class="card-header nocollapse bg-info msg-bar">
      <span><b>Service Line Name: </b>{{ serviceLineName }}</span>
    </div>
    <ag-grid-angular style="height:400px;" class="ag-theme-balham"
                     [rowData]="serviceLineSurveyUnMapList"
                     [columnDefs]="unMappedSurveyColumns"
                     (rowSelected)="onRowSurveySelected($event)"
                     rowSelection="multiple">
    </ag-grid-angular>
  </div>
  <div class="modal-footer">
    <button class="btn btn-secondary btn-sm btn-action"
            (click)="modal.dismiss(); surveyForm.reset()">
      <i class="fa fa-times"></i> Close
    </button>
    <button class="btn btn-primary btn-sm btn-action"
            (click)="modal.close(); mapSurveyList()">
      <i class="fa fa-street-view"></i> Map
    </button>
  </div>
</ng-template>

<!-- ── Map Providers Modal ───────────────────────────────────────────────── -->
<ng-template #mapProviderModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Map Service Provider(s)</h5>
    <button type="button" class="btn-close" aria-label="Close"
            (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body p-0">
    <div class="card-header nocollapse bg-info msg-bar">
      <span><b>Service Line Name: </b>{{ serviceLineName }}</span>
    </div>
    <ag-grid-angular style="height:400px;" class="ag-theme-balham"
                     [rowData]="serviceLineServiceProviderUnMapList"
                     [columnDefs]="unMappedServiceProviderColumns"
                     (rowSelected)="onRowServiceProviderSelected($event)"
                     rowSelection="multiple">
    </ag-grid-angular>
  </div>
  <div class="modal-footer">
    <button class="btn btn-secondary btn-sm btn-action" (click)="modal.dismiss()">
      <i class="fa fa-times"></i> Close
    </button>
    <button class="btn btn-primary btn-sm btn-action"
            (click)="modal.close(); mapServiceProviderList()">
      <i class="fa fa-users"></i> Map
    </button>
  </div>
</ng-template>

<!-- ── Survey Schedule Modal ─────────────────────────────────────────────── -->
<ng-template #surveyScheduleModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Survey Schedule</h5>
    <button type="button" class="btn-close" aria-label="Close"
            (click)="modal.dismiss(); surveyScheduleForm.reset()"></button>
  </div>
  <div class="modal-body">
    <div class="card-header nocollapse bg-info msg-bar">
      <span><b>Service Line Name: </b>{{ serviceLineName }}</span>
      <span><b>&nbsp;Survey Name: </b>{{ currentSelectedSurveyName }}</span>
    </div>
    <form [formGroup]="surveyScheduleForm" class="mt-2">
      <div class="row align-items-center px-2">
        <label class="col-md-4 col-form-label">Select Date Range</label>
        <div class="col-md-8">
          <input type="text" placeholder="Select date range"
                 class="form-control form-control-sm"
                 (bsValueChange)="updateDateRange($event)"
                 readonly bsDaterangepicker
                 [(ngModel)]="dateRangePickerModel"
                 [ngModelOptions]="{standalone: true}" />
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button class="btn btn-secondary btn-sm btn-action"
            (click)="modal.dismiss(); surveyScheduleForm.reset()">
      <i class="fa fa-times"></i> Close
    </button>
    <button class="btn btn-primary btn-sm btn-action"
            [disabled]="!dateRangePickerModel || dateRangePickerModel.length === 0"
            (click)="modal.close(); saveSurveySchedule()">
      <i class="fa fa-calendar"></i> Schedule
    </button>
  </div>
</ng-template>

<!-- ── Copy Survey Modal ─────────────────────────────────────────────────── -->
<ng-template #copySurveyModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Copy Survey</h5>
    <button type="button" class="btn-close" aria-label="Close"
            (click)="modal.dismiss(); copySurveyForm.reset()"></button>
  </div>
  <div class="modal-body">
    <div class="card-header nocollapse bg-info msg-bar">
      <span><b>Service Line Name: </b>{{ serviceLineName }}</span>
      <span><b>&nbsp;Source Survey: </b>{{ currentSelectedSurveyName }}</span>
    </div>
    <form [formGroup]="copySurveyForm" class="mt-2 px-1">
      <div class="mb-2">
        <label class="form-label">New Survey Name</label>
        <input type="text" formControlName="surveyName"
               class="form-control form-control-sm" />
      </div>
      <div class="mb-2 d-flex align-items-center gap-2">
        <input type="checkbox" id="isIncludeResponses"
               formControlName="isIncludeResponses" class="form-check-input" />
        <label class="form-check-label" for="isIncludeResponses">
          Copy with previous responses
        </label>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button class="btn btn-secondary btn-sm btn-action"
            (click)="modal.dismiss(); copySurveyForm.reset()">
      <i class="fa fa-times"></i> Close
    </button>
    <button class="btn btn-primary btn-sm btn-action"
            [disabled]="copySurveyForm.invalid"
            (click)="modal.close(); copySurvey()">
      <i class="fa fa-copy"></i> Copy
    </button>
  </div>
</ng-template>

<!-- ── Delete Survey Modal ───────────────────────────────────────────────── -->
<ng-template #deleteSurveyModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Delete Survey Confirmation</h5>
    <button type="button" class="btn-close" aria-label="Close"
            (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body">
    <p>Are you sure you want to delete this survey?</p>
    <p class="text-danger">
      <strong>Note:</strong><br />
      The available user responses for this particular Service Line with this Survey
      will also be deleted.
    </p>
  </div>
  <div class="modal-footer">
    <button class="btn btn-secondary btn-sm btn-action" (click)="modal.dismiss()">
      <i class="fa fa-times"></i> Close
    </button>
    <button class="btn btn-danger btn-sm btn-action"
            (click)="modal.close(); deleteSurvey()">
      <i class="fa fa-trash"></i> Delete
    </button>
  </div>
</ng-template>

<!-- ── Delete Provider Modal ─────────────────────────────────────────────── -->
<ng-template #deleteProviderModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Delete Service Provider Confirmation</h5>
    <button type="button" class="btn-close" aria-label="Close"
            (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body">
    <p>Are you sure you want to delete this Service Provider?</p>
    <p class="text-danger">
      <strong>Note:</strong><br />
      The available user responses for this particular Service Line and Provider
      will also be deleted.
    </p>
  </div>
  <div class="modal-footer">
    <button class="btn btn-secondary btn-sm btn-action" (click)="modal.dismiss()">
      <i class="fa fa-times"></i> Close
    </button>
    <button class="btn btn-danger btn-sm btn-action"
            (click)="modal.close(); deleteServiceProvider()">
      <i class="fa fa-trash"></i> Delete
    </button>
  </div>
</ng-template>

<!-- ── Format Download Modal ─────────────────────────────────────────────── -->
<ng-template #formatDownloadModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Survey Format Download</h5>
    <button type="button" class="btn-close" aria-label="Close"
            (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body">
    <div class="card-header bg-info msg-bar">
      <b>Company Name: </b>&nbsp;{{ currentFormatCompanyName }}
    </div>
    <form [formGroup]="exceptionalFormatForm" class="mt-2">
      <div class="mb-2">
        <label class="form-label">Survey Name</label>
        <select class="form-select form-select-sm" formControlName="formatsurveyId"
                (change)="currentFormatSurveyId = exceptionalFormatForm.get('formatsurveyId')?.value">
          <option *ngFor="let survey of serviceLineSurveyMapList" [ngValue]="survey?.surveyId">
            {{ survey.surveyName }}
          </option>
        </select>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button class="btn btn-secondary btn-sm btn-action" (click)="modal.dismiss()">
      <i class="fa fa-times"></i> Close
    </button>
    <button class="btn btn-primary btn-sm btn-action"
            [disabled]="currentFormatSurveyId <= 0"
            (click)="modal.close(); downloadFormat()">
      <i class="fa fa-download"></i> Format Download
    </button>
  </div>
</ng-template>

<!-- ── Users Download Modal ──────────────────────────────────────────────── -->
<ng-template #usersDownloadModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Download Users</h5>
    <button type="button" class="btn-close" aria-label="Close"
            (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body">
    <form [formGroup]="usersDownloadForm">
      <div class="mb-2">
        <label class="form-label">Survey Name</label>
        <select class="form-select form-select-sm" formControlName="usersmappedsurveyId"
                (change)="currentUserDownLoadSurveyId = usersDownloadForm.get('usersmappedsurveyId')?.value">
          <option *ngFor="let survey of serviceLineSurveyMapList" [ngValue]="survey?.surveyId">
            {{ survey.surveyName }}
          </option>
        </select>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button class="btn btn-secondary btn-sm btn-action" (click)="modal.dismiss()">
      <i class="fa fa-times"></i> Close
    </button>
    <button class="btn btn-primary btn-sm btn-action"
            [disabled]="currentUserDownLoadSurveyId <= 0"
            (click)="modal.close(); userDownload()">
      <i class="fa fa-download"></i> Download
    </button>
  </div>
</ng-template>

<!-- ── Respondent Type Modal ─────────────────────────────────────────────── -->
<ng-template #respondentModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Respondent Type</h5>
    <button type="button" class="btn-close" aria-label="Close"
            (click)="modal.dismiss(); respendentForm.reset()"></button>
  </div>
  <div class="modal-body">
    <form [formGroup]="respendentForm">
      <label class="form-label">Your role in the relationship?</label>
      <select class="form-select form-select-sm" formControlName="respondentId"
              (change)="getRespondentId()">
        <option *ngFor="let r of respondentsTypesList?.listOfRespondents"
                [ngValue]="r?.respondentId">
          {{ r.respondentName }}
        </option>
      </select>
    </form>
  </div>
  <div class="modal-footer">
    <button class="btn btn-secondary btn-sm btn-action"
            (click)="modal.dismiss(); respendentForm.reset()">
      <i class="fa fa-times"></i> Close
    </button>
    <button class="btn btn-primary btn-sm btn-action"
            [disabled]="tempRespondentId < 0"
            (click)="modal.close(); saveRespondent()">
      <i class="fa fa-save"></i> Save
    </button>
  </div>
</ng-template>

<!-- ── Exceptional User Modal ────────────────────────────────────────────── -->
<ng-template #exceptionalUserModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Survey Exceptional User Mapping</h5>
    <button type="button" class="btn-close" aria-label="Close"
            (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body p-0">
    <div class="card-header bg-info msg-bar">
      <b>Company Name: </b>&nbsp;{{ currentCompanyName }}
    </div>
    <form [formGroup]="exceptionalUserForm" class="mt-2 p-2">
      <div class="mb-2">
        <label class="form-label">Survey Name</label>
        <select class="form-select form-select-sm" formControlName="surveyId"
                (change)="loadQuestionByCompany()">
          <option *ngFor="let survey of serviceLineSurveyMapList" [ngValue]="survey?.surveyId">
            {{ survey.surveyName }}
          </option>
        </select>
      </div>
    </form>
    <ag-grid-angular style="height:300px;" class="ag-theme-balham"
                     [rowData]="companyUserList"
                     [columnDefs]="companyUserColumnDefs"
                     rowSelection="multiple">
    </ag-grid-angular>
  </div>
  <div class="modal-footer">
    <button class="btn btn-secondary btn-sm btn-action" (click)="modal.dismiss()">
      <i class="fa fa-times"></i> Close
    </button>
  </div>
</ng-template>

<!-- ── Answers Upload Modal ──────────────────────────────────────────────── -->
<ng-template #answersUploadModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Survey Answers Upload</h5>
    <button type="button" class="btn-close" aria-label="Close"
            (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body p-0">
    <div class="card-header bg-info msg-bar">
      <b>Company Name: </b>&nbsp;{{ currentUploadCompanyName }}
    </div>
    <form [formGroup]="exceptionalAnswersUpload" class="p-2">
      <div class="mb-2">
        <label class="form-label">Survey Name</label>
        <select class="form-select form-select-sm" formControlName="answersuploadsurveyId"
                (change)="currentUploadSurveyId = exceptionalAnswersUpload.get('answersuploadsurveyId')?.value; loadUserForUploadAnswers()">
          <option *ngFor="let survey of serviceLineSurveyMapList" [ngValue]="survey?.surveyId">
            {{ survey.surveyName }}
          </option>
        </select>
      </div>
      <div class="mb-2">
        <label class="form-label">Users</label>
        <select class="form-select form-select-sm" formControlName="answersuploaduserId"
                (change)="currentUploadUserId = exceptionalAnswersUpload.get('answersuploaduserId')?.value; loadStatus()">
          <option *ngFor="let user of companyUserList" [ngValue]="user?.userId">
            {{ user.userName }}
          </option>
        </select>
      </div>
      <div class="mb-2">
        <label class="form-label">Status</label>
        <select class="form-select form-select-sm" formControlName="statusId"
                (change)="currentUploadStatusId = exceptionalAnswersUpload.get('statusId')?.value">
          <option *ngFor="let status of statusList" [ngValue]="status?.statusId">
            {{ status.statusName }}
          </option>
        </select>
      </div>
      <div class="mb-2">
        <label class="form-label">File</label>
        <input type="file" formControlName="file" class="form-control form-control-sm"
               (change)="incomingFile($event)" accept=".xlsx" />
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button class="btn btn-secondary btn-sm btn-action" (click)="modal.dismiss()">
      <i class="fa fa-times"></i> Close
    </button>
    <button class="btn btn-primary btn-sm btn-action"
            [disabled]="exceptionalAnswersUpload.invalid"
            (click)="modal.close(); answersUpload()">
      <i class="fa fa-upload"></i> Upload
    </button>
  </div>
</ng-template>

<!-- ── Upload Document Modal ─────────────────────────────────────────────── -->
<ng-template #uploadDocumentModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Upload Document</h5>
    <button type="button" class="btn-close" aria-label="Close"
            (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body">
    <form [formGroup]="uploadSurveyForm">
      <div class="row mb-2 align-items-end">
        <div class="col-md-4">
          <label class="form-label">
            Document Name <span class="text-danger">*</span>
          </label>
          <input type="text" formControlName="documentname"
                 class="form-control form-control-sm" />
        </div>
        <div class="col-md-5">
          <label class="form-label">File</label>
          <input type="file" formControlName="file"
                 class="form-control form-control-sm"
                 (change)="selectFile($event, uploadSurveyForm)" />
        </div>
        <div class="col-md-3">
          <button class="btn btn-primary btn-sm btn-action w-100"
                  [disabled]="uploadSurveyForm.invalid"
                  (click)="uploadDocument(uploadSurveyForm)">
            <i class="fa fa-cloud-upload"></i> Upload
          </button>
        </div>
      </div>
    </form>
    <ag-grid-angular style="height:300px;" class="ag-theme-balham"
                     [rowData]="documentList"
                     [columnDefs]="generalDocumentColumnDefs"
                     rowSelection="multiple">
    </ag-grid-angular>
  </div>
  <div class="modal-footer">
    <button class="btn btn-secondary btn-sm btn-action" (click)="modal.dismiss()">
      <i class="fa fa-times"></i> Close
    </button>
  </div>
</ng-template>

<!-- ── Email Config Modal ────────────────────────────────────────────────── -->
<ng-template #emailSettingModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Email Configuration</h5>
    <button type="button" class="btn-close" aria-label="Close"
            (click)="modal.dismiss(); emailConfigurationForm.reset()"></button>
  </div>
  <div class="modal-body">
    <form [formGroup]="emailConfigurationForm">
      <div class="row mb-2">
        <label class="col-md-3 col-form-label">Email</label>
        <div class="col-md-7">
          <input type="text" formControlName="email"
                 class="form-control form-control-sm" />
        </div>
      </div>
      <div class="row mb-2">
        <label class="col-md-3 col-form-label">Password</label>
        <div class="col-md-7">
          <input type="password" formControlName="emailPassword"
                 class="form-control form-control-sm" />
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button class="btn btn-secondary btn-sm btn-action"
            (click)="modal.dismiss(); emailConfigurationForm.reset()">
      <i class="fa fa-times"></i> Close
    </button>
    <button class="btn btn-primary btn-sm btn-action"
            [disabled]="emailConfigurationForm.invalid"
            (click)="modal.close(); saveEmailConfiguration()">
      <i class="fa fa-save"></i> Save
    </button>
  </div>
</ng-template>

<!-- ── Template Survey Settings Modal ───────────────────────────────────── -->
<ng-template #templateModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Master Survey Settings</h5>
    <button type="button" class="btn-close" aria-label="Close"
            (click)="modal.dismiss(); resetTemplateForm()"></button>
  </div>
  <div class="modal-body">
    <form [formGroup]="isTemplateSurveyForm">
      <div class="mb-2">
        <label class="form-label">Provider Survey</label>
        <select class="form-select form-select-sm" formControlName="providersurveyId"
                (change)="providerSurveyId = isTemplateSurveyForm.get('providersurveyId')?.value">
          <option *ngFor="let survey of serviceLineSurveyMapList" [ngValue]="survey?.surveyId">
            {{ survey.surveyName }}
          </option>
        </select>
      </div>
      <div class="mb-2">
        <label class="form-label">Client Survey</label>
        <select class="form-select form-select-sm" formControlName="clientsurveyId"
                (change)="clientSurveyId = isTemplateSurveyForm.get('clientsurveyId')?.value">
          <option *ngFor="let survey of serviceLineSurveyMapList" [ngValue]="survey?.surveyId">
            {{ survey.surveyName }}
          </option>
        </select>
      </div>
      <div class="row mb-2">
        <div class="col-md-6 d-flex align-items-center gap-2">
          <input type="checkbox" formControlName="isTemplateSurvey"
                 class="form-check-input"
                 (change)="onIsTemplateSurveyChange($event)" />
          <label class="form-check-label">Is Template Survey</label>
        </div>
        <div class="col-md-6 d-flex align-items-center gap-2">
          <input type="checkbox" formControlName="isProviderSurvey"
                 class="form-check-input"
                 (change)="onIsProviderSurveyChange($event)" />
          <label class="form-check-label">Is Provider Overview Survey</label>
        </div>
      </div>
      <div class="mb-2 d-flex align-items-center gap-2">
        <input type="checkbox" formControlName="showDownloadReport"
               class="form-check-input" />
        <label class="form-check-label">Show Download Report</label>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button class="btn btn-secondary btn-sm btn-action"
            (click)="modal.dismiss(); resetTemplateForm()">
      <i class="fa fa-times"></i> Close
    </button>
    <button class="btn btn-primary btn-sm btn-action"
            [disabled]="isTemplateSurveyChecked && (providerSurveyId <= 0 || clientSurveyId <= 0)"
            (click)="modal.close(); saveTemplateSurvey()">
      <i class="fa fa-save"></i> Save
    </button>
  </div>
</ng-template>

<!-- ── Survey Provider Language Modal ───────────────────────────────────── -->
<ng-template #surveyProviderLanguageModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Survey Company Language Settings</h5>
    <button type="button" class="btn-close" aria-label="Close"
            (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body p-0">
    <form [formGroup]="surveyProviderLanguageForm" class="p-2">
      <div class="mb-2">
        <label class="form-label">Service Provider</label>
        <select class="form-select form-select-sm" formControlName="companyId">
          <option value="">--Select--</option>
          <option *ngFor="let provider of serviceLineServiceProviderMapList"
                  [ngValue]="provider?.companyId">
            {{ provider.companyName }}
          </option>
        </select>
      </div>
      <div class="mb-2">
        <label class="form-label">Language</label>
        <select class="form-select form-select-sm" formControlName="languageId">
          <option value="">--Select--</option>
          <option *ngFor="let lang of languageList" [ngValue]="lang?.languageId">
            {{ lang.name }}
          </option>
        </select>
      </div>
      <div class="d-flex gap-2 mb-2">
        <button class="btn btn-secondary btn-sm btn-action" (click)="modal.dismiss()">
          <i class="fa fa-times"></i> Close
        </button>
        <button class="btn btn-primary btn-sm btn-action"
                [disabled]="!surveyProviderLanguageForm.value.companyId || !surveyProviderLanguageForm.value.languageId"
                (click)="saveSurveyProviderLanguage()">
          <i class="fa fa-save"></i> Save
        </button>
      </div>
    </form>
    <isg-grid [rowData]="surveyServiceLineLanguageMappedList"
              [columnDefs]="languageMappingColumnDefs"
              [config]="{height: '200px'}">
    </isg-grid>
  </div>
</ng-template>

<!-- ── Delete Language Mapping Modal ────────────────────────────────────── -->
<ng-template #deleteLanguageMappingModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Delete Confirmation</h5>
    <button type="button" class="btn-close" aria-label="Close"
            (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body">
    <p>Are you sure you want to delete this mapping?</p>
  </div>
  <div class="modal-footer">
    <button class="btn btn-secondary btn-sm btn-action" (click)="modal.dismiss()">
      <i class="fa fa-times"></i> Close
    </button>
    <button class="btn btn-danger btn-sm btn-action"
            (click)="modal.close(); deleteMapping()">
      <i class="fa fa-trash"></i> Delete
    </button>
  </div>
</ng-template>
